import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=399c4d60&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=399c4d60&prod&scoped=true&lang=css"
import style1 from "./BarChart.vue?vue&type=style&index=1&id=399c4d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399c4d60",
  null
  
)

export default component.exports